import { render } from "./CBHIMemberLogin.vue?vue&type=template&id=0dba6598&scoped=true"
import script from "./CBHIMemberLogin.vue?vue&type=script&lang=js"
export * from "./CBHIMemberLogin.vue?vue&type=script&lang=js"

import "./CBHIMemberLogin.vue?vue&type=style&index=0&id=0dba6598&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dba6598"]])

export default __exports__